module.exports = __webpack_public_path__ + "img/callPhone.7ff5e542.png";